import useLocales from "src/hooks/useLocales";
import { EntityAuthField } from "src/services/link/queries/NetTypes";
import * as Yup from "yup";

import { useFieldValidation } from "./useFieldValidation";

export const useFormSchema = (
	fields: EntityAuthField[],
	fieldSelected: string,
	totpNeeded?: boolean,
	userConfirmationNeeded?: boolean,
	isUpdateFlow?: boolean
) => {
	const { translate } = useLocales();

	const validationSchemaFields = useFieldValidation(fields, fieldSelected);

	let validator: Yup.AnySchema = Yup.mixed();

	let totpSchema: {
		[key: string]: Yup.AnySchema;
	} = {};

	let userConfirmSchema: {
		[key: string]: Yup.AnySchema;
	} = {};

	totpSchema["totp"] = validator.required(translate(`connect_panel.add_2fa`));

	const totpValidationSchema = Yup.object().shape(totpSchema);
	const userConfirmValidationSchema = Yup.object().shape(userConfirmSchema);

	if (userConfirmationNeeded) return userConfirmValidationSchema;
	if (totpNeeded) return totpValidationSchema;
	if (isUpdateFlow) return Yup.object().shape({});

	return Yup.object().shape(validationSchemaFields);
};
